import { Attachment } from "../components/attachment/Attachment";
import { Checkbox } from "../components/checkbox/Checkbox";
import { CityState } from "../components/citystate/CityState";
import { Event, EventListener } from "./Event";
import { Label } from "../components/label/Label";
import { Location } from "../components/location/Location";
import { RadioGroup } from "../components/radio/RadioGroup";
import { Switch } from "../components/switch/Switch";
import { Textbox } from "../components/textbox/Textbox";
import { UnitInputField } from "../components/unitinputfield/UnitInputField";

export type PrintableEventTarget = Attachment | Checkbox | CityState | Location | RadioGroup | Switch | Textbox |
    UnitInputField;

export interface PrintableListener extends EventListener<PrintableEvent> {
}

export class PrintableEvent extends Event<PrintableEventTarget> {
    private _printableLabel: Label = null;

    constructor(component: PrintableEventTarget, printableLabel?: Label) {
        super(component);
        this._printableLabel = printableLabel;
    }

    public get printableLabel(): Label {
        return this._printableLabel;
    }

    public get printable(): boolean {
        return this.target["printable"];
    }
}
